import apiPrueba from "./seccion/apiPrueba";
import apiRegistro from "./seccion/apiClienteRegistro";
import apiSolDoc from "./seccion/apiClienteSolDoc";
import ApiReqJson from "./ApiReqJson";

const DataApi = {
  Prueba: apiPrueba,
  ClienteRegistro: apiRegistro,
  ClienteSolDoc:apiSolDoc,
  PutFile: async (url, objectFile)=>{
    return await ApiReqJson.requestPUTFile(url, objectFile, 'file');
  },
  GetTextoAppAsesor:async()=>{
    return await ApiReqJson.requestGET("https://vivalia.mx/texto-appcliente");
    
  }
};

export default DataApi;
